import React, { useCallback, useState } from 'react';
import { useRouter } from 'next/router';
import Grid from '@components/core/layout/Grid';
import RichText from '@components/core/RichText';
import Filters from '@components/Filters';

// Part before LookUp are keys and most be one of the domains
const lookUps = {
  kinderopvang: {
    BSO: 'Buitenschoolse opvang',
    POV: 'Peuteropvang',
    KDV: 'Kinderdagverblijf',
  },
};

export default function KOVFilterSection(props: any) {
  const [ selectedProductType, setProductType ] = useState(null);
  const [ selectedLocation, setLocation ] = useState({
    value: '',
    isValid: true,
    validState: { }, // key: type of validation, value: boolean
    showErrorMessage: false,
  });
  const [ buttonIsDisabled, setButtonIsDisabled ] = useState(true);

  const router = useRouter();

  const handleEmitLocation = (e) => {
    setLocation({
      value: e.target.value ,
      isValid: true,
      validState: { }, // key: type of validation, value: boolean
      showErrorMessage: false,
    });
    setButtonIsDisabled(false);
  };

  const applyFilter = useCallback(() => {
    // Convert to url friendly instead of options friendly
    const selectedProductValues = selectedProductType?.map( productType => productType.value).join();
    router.push({
      pathname: '/kinderopvang-locaties',
      query: {
        ...(selectedProductValues ? { productType: selectedProductValues } : {}),
        ...(selectedLocation?.value ? { location: selectedLocation.value } : {}),
      },
    }, undefined, { scroll: false });
  }, [ router, selectedProductType, selectedLocation ]);

  const hasHeading = props.heading?.text?.length > 0;
  const hasIntro = props.intro?.text?.length > 0;
  const hasText = hasHeading || hasIntro;
  // De intro brengt zijn eigen ondermarge mee, een losse heading niet
  const searchSpacing = hasIntro ? 'mt-2 md:mt-4' : 'mt-6 md:mt-8';

  return (
    <Grid>
      {
        hasText &&
        <div className='col-span-12 md:col-span-8 md:col-start-3 text-center'>
          { hasHeading && <RichText text={ props.heading.text } /> }
          { hasIntro && <RichText text={ props.intro.text } /> }
        </div>
      }
      <div className={ sq`
        col-span-12 md:col-span-10 md:col-start-2 p-4 bg-primary-50 rounded-[30px] xl:rounded-[60px]
        ${ hasText ? searchSpacing : '' }
      ` }>
        <div className='flex flex-col xl:flex-row xl:whitespace-nowrap'>
          <Filters
            position='section'
            options={ {
              productTypes: lookUps.kinderopvang,
            } }
            selectedProductType={ selectedProductType }
            selectedLocation={ selectedLocation }
            buttonIsDisabled={ buttonIsDisabled }
            emit={ {
              productType: setProductType,
              location: handleEmitLocation,
              applyFilter,
              disableApplyButton: setButtonIsDisabled,
            } }
            buttonLabel='Bekijk locaties'
          />
        </div>
      </div>
    </Grid>
  );
}
